import { Pipe, PipeTransform } from "@angular/core";

interface InputObject {
	[key: string]: any;
}

type Input = string | InputObject;

@Pipe({
	name: "filter",
	pure: false
})
export class FilterPipe implements PipeTransform {
	public transform(value: Input[], ...parameters: string[]) {
		// special case for empty input
		if (!value || value.length === 0) {
			return [];
		}

		// as long as they at least gave us the filter string
		if (parameters && parameters.length >= 1) {
			const filter = parameters[0];
			const key = parameters.length >= 2 ? parameters[1] : undefined;
			return value.filter((v) => {
				if (isInputObject(v)) {
					if (key) {
						// key was provided, return this one if that key is present and matches the filter
						if (key in v) {
							// key was on the object, apply filter to that key
							return applyFilter(v[key], filter);
						} else {
							// key wasn't on the object, don't do this one
							return false;
						}
					} else {
						// key was not provided, return this one we can't filter
						return true;
					}
				} else {
					// this one is a string, just apply the filter
					return applyFilter(v, filter);
				}
			});
		}
	}
}

function isInputObject(x: Input): x is InputObject {
	return typeof x === "object";
}

/**
 * @return true if the input object contains the filter substring
 */
function applyFilter(input: any, filter: string) {
	if (filter) {
		return `${input}`.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) >= 0;
	} else {
		return true;
	}
}
